import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import moment from "moment";

import CardsList from "@/components/CardsList";

import {PlayerAPI} from "@/api/player";

import "./index.scss";

const PlayerStatsContainer = (props) => {
	const {type, player} = props;

	const seasonId = useSelector((state) => state?.season?.id);

	const [stats, setStats] = useState();
	const [statsDate, setStatsDate] = useState(new Date());

	const getRPEStats = async () => {
		const selectedDate = moment(statsDate);
		const fromDate = selectedDate.startOf("isoWeek").format("YYYY-MM-DD");
		const toDate = selectedDate.endOf("isoWeek").format("YYYY-MM-DD");
		// const fromDate = "2025-01-27";
		// const toDate = "2025-02-02";

		let promises = [];
		promises.push(
			PlayerAPI.listRPE({
				playerId: player.id,
				fromDate,
				toDate,
				// seasonId,
			}),
		);
		try {
			let responses = await Promise.all(promises);
			responses = responses.map((r, k) => {
				const totalBox = {
					eventDuration: 0,
					avgRpe: 0,
					trainingLoad: 0,
				};

				let totalRpe = 0;
				r.forEach((rd) => {
					totalRpe += parseInt(rd.rpe);
					totalBox.eventDuration += rd.eventDuration;
					totalBox.trainingLoad += rd.trainingLoad;
				});
				totalBox.avgRpe = Math.round((totalRpe / r.length) * 100) / 100;

				return {
					player: player,
					items: [...r, totalBox],
				};
			});
			setStats(responses);
		} catch (error) {
			console.log(error);
		}
	};

	const getTQRStats = async () => {
		const fromDate = moment(statsDate).startOf("isoWeek").format("YYYY-MM-DD");
		const toDate = moment(statsDate).endOf("isoWeek").format("YYYY-MM-DD");
		// const fromDate = "2025-01-27";
		// const toDate = "2025-02-02";

		let promises = [];
		promises.push(PlayerAPI.playerListTQR(player.id, {fromDate, toDate}));

		try {
			let responses = await Promise.all(promises);
			responses = responses.map((r, k) => {
				return {
					player: player,
					items: r,
				};
			});
			setStats(responses);
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		if (player?.id?.length) {
			switch (type) {
				case "rpe":
					getRPEStats();
					break;
				case "tqr":
					getTQRStats();
					break;
				default:
					break;
			}
		}
	}, [type, player, statsDate]);

	const getListConfiguration = (item) => {
		switch (type) {
			case "rpe":
				return {
					data: item.items?.filter((i) => i.avgRpe || i.rpe > 0),
					customClassName: (item) => (item.avgRpe ? "total" : ""),
				};
			case "tqr":
				return {
					data: item.items?.filter((i) => parseInt(i.tqrValue) > 0),
				};
			default:
				return {};
		}
	};

	const getCardsList = (stat) => {
		let list = <></>;
		switch (type) {
			case "rpe":
				list = (
					<CardsList
						type="rpe_stat"
						listConfiguration={getListConfiguration(stat)}
						defaultSortedField="trainingDate"
						defaultSortedOrder="ascend"
						fitHeight
					/>
				);
				break;
			case "tqr":
				list = (
					<CardsList
						type="tqr_stat"
						listConfiguration={getListConfiguration(stat)}
						defaultSortedField="tqrDate"
						defaultSortedOrder="ascend"
						fitHeight
					/>
				);
				break;
			default:
				break;
		}

		return list;
	};

	return (
		<div className="measurements-container">
			<div className="row players-stats">
				{stats?.map((s, k) => {
					return (
						<div className="col-12 padding-small" key={k}>
							<div className="single-player-stat mb-2">
								<div className="player-name">
									{type === "rpe" ? "Carico attuale" : "Stato di forma attuale"}
								</div>
								{getCardsList(s)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default PlayerStatsContainer;
